module.exports = __webpack_public_path__ + "img/banner_left.9b67b05e.png";